import { API_URL } from "../config/connect";
import { apiFetch } from "../utils/apiErrorHandler";

export const loginUser = async (phoneNumber) => {
    try {
        // apiFetch automatically:
        // - Adds Accept-Language header with current user's language
        // - Extracts error messages from backend response format
        // - Throws errors with proper message from backend
        const data = await apiFetch(`${API_URL}/api/v1/auth/login`, {
            method: 'POST',
            body: JSON.stringify({ phone_number: phoneNumber }),
        });
        
        // Согласно документации, успешный ответ: { links: [...] }
        return data;

    } catch (error) {
        // Error message is already extracted from backend response
        // Backend sends localized messages based on Accept-Language header
        console.error("Login error:", error.message);
        throw error;
    }
};